import React, { Fragment, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { H3, H5, LI, P, UL } from "../../../AbstractElements";
import CountUp from 'react-countup';
import { awaitSpare, Close, Closed, Collection, Connection, ConnectionMeter, Due, Dues, InProgress, Invoice, Loss, NewOrder, Open, Profit, serviceMeter, ThisMonth, Today } from "../../../Constant";
import { useSelector } from "react-redux";

const MonthCollMeter = (collection) => {
    const authState = useSelector((state) => state.auth)
    const collectionMeter = collection.collection;
    return (
        <Fragment>
            <Col   md="6" lg="4">
                <Row>
                    {/* <Col xl="12" md="12" className="box-col-12">
                        <Card className="testimonial">
                            <CardBody>
                                <Image attrImage={{ className: "img-90 user-img",src:`${require("../../../assets/images/general-widget/testimonial.png")}`}}/>
                                <H5>{KelvinELedbetter}</H5>
                                <P>{UserProfileDesc4}</P>
                            </CardBody>
                        </Card>
                    </Col> */}
                    <Col xl="12" md="12" className="box-col-12">
                        <Card className="order-widget">
                            <CardHeader className="pb-0">
                                <H3> {serviceMeter} </H3>
                            </CardHeader>
                            <CardBody>
                                <Row className="heder-widget">
                                    <Col className="col-5">
                                        <span>{ThisMonth}</span>
                                        <H3 attrH3={{ className: "total-num counter" }}>
                                            <CountUp end={collectionMeter.percentage} duration={0.8} decimals={2} className="mb-0 counter" style={{ color: 'var(--default-primary)' }} />%
                                        </H3>
                                    </Col>
                                    <Col className="col-7">
                                        <div className="text-end">
                                            <UL attrUL={{ className: "simple-list" }}>
                                                <LI>{Open}
                                                    <span className="product-stts font-primary m-l-10"> {collectionMeter?.open}
                                                    </span>
                                                </LI>
                                                <LI>{InProgress}
                                                    <span className="product-stts font-primary m-l-10">{collectionMeter?.in_progress}
                                                    </span>
                                                </LI>
                                                <LI>{awaitSpare}
                                                    <span className="product-stts font-primary m-l-10"> {collectionMeter?.awaiting}
                                                    </span>
                                                </LI>
                                                <LI>{Closed}
                                                    <span className="product-stts font-primary m-l-10"> {collectionMeter?.closed}
                                                    </span>
                                                </LI>
                                            </UL>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="new-order">
                                    <div>
                                        <div className="progress sm-progress-bar">
                                            <div className="progress-bar bg-secondary" role="progressbar" style={{ width: `${collectionMeter.percentage}%` }} aria-valuenow={collectionMeter.percentage} aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Fragment>
    );
};

export default MonthCollMeter;